import { getCountry } from '@iwIntlProvider/CountryProvider';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './ApprovalExpiredView.module.css';
import { REQUEST_CHANGE_ROUTER } from '../../../iwRouter/IwRouter.actions';
import StopWatchSVG from '../../../svgComponents/stopWatchSVG/StopWatchSVG';
import { TickCircleSVG } from '../../../svgComponents/tickCircleSVG';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    requestReapply: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/apply-flexi-loan/'
            }
        })
});

const ApprovalExpiredView = ({
    requestReapply
}: ReturnType<typeof mapDispatchToProps>) => {
    return (
        <MainSectionWrapper>
            <div className={styles.card}>
                <div className={styles.svgContainer}>
                    <StopWatchSVG />
                </div>

                <div className={styles.title}>
                    <FormattedMessage
                        id="_.loan_builder.expired.title"
                        defaultMessage="Your offer’s expired: apply again?"
                    />
                </div>

                <div className={styles.subtitle}>
                    <FormattedMessage
                        id="_.loan_builder.expired.subtitle"
                        defaultMessage="It should be straightforward to re-apply if your business is in a similar position to before."
                    />
                </div>
                <hr className={styles.divider} />

                <div className={styles.reminderTitle}>
                    <FormattedMessage
                        id="_.loan_builder.expired.reminder_title"
                        defaultMessage="Here are a few reminders on iwoca loans:"
                    />
                </div>
                <div className={styles.reminders}>
                    <div className={styles.reminder}>
                        <div className={styles.tickContainer}>
                            <TickCircleSVG />
                        </div>
                        <FormattedMessage
                            tagName="span"
                            id="_.loan_builder.expired.decision"
                            defaultMessage="<strong>Get a decision in 24 hours:</strong> it takes ten minutes to apply, and you’ll get a decision back within one working day."
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>
                            }}
                        />
                    </div>
                    <div className={styles.reminder}>
                        <div className={styles.tickContainer}>
                            <TickCircleSVG />
                        </div>
                        <FormattedMessage
                            tagName="span"
                            id="_.loan_builder.expired.borrow_amount"
                            defaultMessage="<strong>Borrow £1,000 - £1,000,000:</strong>."
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>
                            }}
                        />
                    </div>
                    <div className={styles.reminder}>
                        <div className={styles.tickContainer}>
                            <TickCircleSVG />
                        </div>
                        <FormattedMessage
                            tagName="span"
                            id="_.loan_builder.expired.repay_early"
                            defaultMessage="<strong>Repay early with no fees:</strong> we’ll only charge interest for the days you have the money."
                            values={{
                                strong: (chunks) => <strong>{chunks}</strong>
                            }}
                        />
                    </div>
                </div>

                <div className={styles.questions}>
                    <FormattedMessage
                        tagName="strong"
                        id="_.loan_builder.expired.questions"
                        defaultMessage="If you have any questions call us on {phoneNumber}."
                        values={{
                            phoneNumber: (
                                <a
                                    href={
                                        getCountry() === 'DE'
                                            ? 'tel:069 9432 3020 '
                                            : 'tel:020 3778 0274'
                                    }
                                    className={styles.phoneNumber}
                                >
                                    <FormattedMessage
                                        tagName="strong"
                                        id="_.loan_builder.expired.phone_number"
                                        defaultMessage="020 3778 0274"
                                    />
                                </a>
                            )
                        }}
                    />
                </div>

                <div className={styles.cta}>
                    <Button
                        data-testid="re-apply-cta"
                        variant="primary"
                        className={styles.ctaButton}
                        onClick={requestReapply}
                        data-action-name="Approval expired reapply"
                    >
                        <FormattedMessage
                            id="_.loan_builder.expired.cta"
                            defaultMessage="Re-apply"
                        />
                    </Button>
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(ApprovalExpiredView);
